import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MaybeCancellationAndRefundPolicies = ({
  policySettings
}) => {
  const refundPolicy = policySettings.customPolicyEnabled ? policySettings.refundPolicyText : '';
  const cancellationPolicy = policySettings.customPolicyEnabled ? policySettings.cancellationPolicyText : '';
  if (!refundPolicy && !cancellationPolicy) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [cancellationPolicy && /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.merchantTermsOfService.cancellationPolicyLabel"
      }), cancellationPolicy]
    }), refundPolicy && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.merchantTermsOfService.refundPolicyLabel"
      }), refundPolicy]
    })]
  });
};
export default MaybeCancellationAndRefundPolicies;